<nb-card>
  <nb-card-header>{{ 'auth.account.title' | translate }}</nb-card-header>
  <nb-card-body>
    <form id="account-activision-form" [formGroup]="accountActivisionForm">
      <app-form-input
        id="email"
        type="email"
        [label]="'auth.account.email' | translate"
        [required]="true"
        formControlName="email"
        [control]="getControl('email')"></app-form-input>
      <app-form-input
        id="account_activision"
        [label]="'auth.account.activision_id' | translate"
        [required]="!this.isUserInternal()"
        formControlName="account_activision"
        [control]="getControl('account_activision')"></app-form-input>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="form-buttons">
      <button nbButton status="danger" (click)="cancel()">{{ 'common.cancel' | translate }}</button>
      <button nbButton status="success" (click)="submit()" [disabled]="!accountActivisionForm.valid">{{ 'common.update' | translate }}</button>
    </div>
  </nb-card-footer>
</nb-card>
